import React, { memo, Suspense, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { CircularProgress } from '@mui/material';

import './App.css';
import Header from './components/Header';
import { authStore } from './stores/AuthStore';
import { userStore } from './stores/UserStore';
import ConfirmDialog from './components/Dialogs/ConfirmDialog';
import { ping } from './services/UsersAPI';
import MuiXLicense from './components/Common/MuiXLicense';
import ToastHost from './components/Common/ToastHost';
import AuthenticatedRoutes from './routes/AuthenticatedRoutes';

const AuthProvider = memo(() => (
  <div className='center-content'>
    <button className='button' onClick={() => authStore.login()}>
      Login To Continue
    </button>
  </div>
));

function App() {
  const { isAuthenticated } = authStore;
  const { isLoading } = userStore;

  useEffect(() => {
    const init = async () => {
      // Ping the database to ensure it's awake before we start making API calls
      ping().catch((error: unknown) => {
        console.warn('Database initialization failed:', error);
      }); // fire and forget

      await authStore.initialize();
    };

    void init().catch((error: unknown) => {
      console.warn('Auth initialization failed:', error);
    });
  }, []);

  useEffect(() => {
    const syncUser = async () => {
      await userStore.syncUser();
    }

    if (isAuthenticated && !userStore.currentUser) {
      void syncUser().catch((error: unknown) => {
        console.warn('User sync failed:', error);
      });
    }
  }, [isAuthenticated]);

  return (
    <div>
      {isLoading && <div className='spinner'><CircularProgress /></div>}
      <Header />
      {userStore.currentUser ? (
        <Suspense fallback={<div className='spinner'><CircularProgress /></div>}>
          <AuthenticatedRoutes />
        </Suspense>
      ) : <AuthProvider />}
      <ConfirmDialog />
      <ToastHost />
      <MuiXLicense />
    </div>
  );
}

export default observer(App);